const LOCALE = 'tr-TR'

const WEEKDAY_SHORT = {
  pazartesi: 'Pzt',
  salı: 'Sal',
  çarşamba: 'Çar',
  perşembe: 'Per',
  cuma: 'Cum',
  cumartesi: 'Cmt',
  pazar: 'Paz',
}

export const lower = (value) => String(value || '').trim().toLocaleLowerCase(LOCALE)
export const upper = (value) => String(value || '').trim().toLocaleUpperCase(LOCALE)
export const capitalize = (value) => {
  const text = lower(value)
  return text.charAt(0).toLocaleUpperCase(LOCALE) + text.slice(1)
}

export function parseDay(date) {
  const [day = '', month = '', year = '', ...rest] = String(date.date || '').trim().split(/\s+/)
  const weekday = rest.join(' ')
  return {
    day,
    month: capitalize(month),
    year,
    weekday: capitalize(weekday),
    short: WEEKDAY_SHORT[lower(weekday)] || capitalize(weekday).slice(0, 3),
  }
}

export function dateRange(days, { withYear = true } = {}) {
  if (!days.length) return ''
  const first = days[0]
  const last = days[days.length - 1]
  const year = withYear ? ` ${last.year}` : ''
  if (first.day === last.day && first.month === last.month) return `${first.day} ${first.month}${year}`
  if (first.month === last.month) return `${first.day}–${last.day} ${first.month}${year}`
  return `${first.day} ${first.month} – ${last.day} ${last.month}${year}`
}
